module.exports = __webpack_public_path__ + "img/diners.26e228b3.svg";